export default __webpack_public_path__ + "content/media/descargarevistasate.fa91c85b.png";